import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { getElementRef } from '../../utils/getElementRef';
import { composeRefs } from '../../hooks/useComposedRefs';
import { jsx as _jsx } from "react/jsx-runtime";
var SlotClone = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, _excluded);
  if ( /*#__PURE__*/React.isValidElement(children)) {
    var childrenRef = getElementRef(children);
    return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, mergeProps(slotProps, children.props)), {}, {
      // @ts-expect-error `ref` не является допустимым свойством для ReactElement, но используется в `getElementRef`
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = 'SlotClone';
var Slottable = function Slottable(_ref) {
  var children = _ref.children;
  return children;
};
export var Slot = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var children = props.children,
    slotProps = _objectWithoutProperties(props, _excluded2);
  var childrenArray = React.Children.toArray(children);
  var slottable = childrenArray.find(isSlottable);
  if (slottable) {
    // новый элемент для рендеринга - это тот, который передан как дочерний элемент `Slottable`
    var newElement = slottable.props.children;
    var newChildren = childrenArray.map(function (child) {
      if (child === slottable) {
        // поскольку новый элемент будет рендериться, нас интересуют только его дочерние элементы (`newElement.props.children`)
        if (React.Children.count(newElement) > 1) {
          return React.Children.only(null);
        }
        return /*#__PURE__*/React.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /*#__PURE__*/_jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
      ref: forwardedRef,
      children: /*#__PURE__*/React.isValidElement(newElement) ? /*#__PURE__*/React.cloneElement(newElement, undefined, newChildren) : null
    }));
  }
  return /*#__PURE__*/_jsx(SlotClone, _objectSpread(_objectSpread({}, slotProps), {}, {
    ref: forwardedRef,
    children: children
  }));
});
Slot.displayName = 'Slot';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

function isSlottable(child) {
  return /*#__PURE__*/React.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  // все свойства дочернего элемента должны переопределять
  var overrideProps = _objectSpread({}, childProps);
  var _loop = function _loop() {
    if (Object.prototype.hasOwnProperty.call(childProps, propName)) {
      var slotPropValue = slotProps[propName];
      var childPropValue = childProps[propName];
      var isHandler = /^on[A-Z]/.test(propName);
      if (isHandler) {
        // если обработчик существует в обоих, мы их объединяем
        if (slotPropValue && childPropValue) {
          overrideProps[propName] = function () {
            childPropValue.apply(void 0, arguments);
            slotPropValue.apply(void 0, arguments);
          };
        }
        // но если он существует только в слоте, мы используем только его
        else if (slotPropValue) {
          overrideProps[propName] = slotPropValue;
        }
      }
      // если это `style`, мы их объединяем
      else if (propName === 'style') {
        overrideProps[propName] = _objectSpread(_objectSpread({}, slotPropValue), childPropValue);
      } else if (propName === 'className') {
        overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(' ');
      }
    }
  };
  for (var propName in childProps) {
    _loop();
  }
  return _objectSpread(_objectSpread({}, slotProps), overrideProps);
}